import { isNotDefined } from '@sgme/fp';
import { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

import { useTargetAccumulatorTileId } from '@/App/tiles/TargetAccumulator/TargetAccumulatorContext.tsx';
import { useAppSelector } from '@/store/hooks.ts';
import { selectTargetAccumulatorSummary } from '@/store/targetAccumulator/selectors.ts';

const Summary = () => {
  const tileId = useTargetAccumulatorTileId();

  const summary = useAppSelector((state) => selectTargetAccumulatorSummary(state, tileId));

  return (
    <div>
      <FormattedMessage id="targetAccumulator.summary.title" />

      <div data-nodrag data-e2e="summary-text">
        {summary === '' || isNotDefined(summary) ? (
          <FormattedMessage id="targetAccumulator.summary.placeholder" />
        ) : (
          summary?.split(/<br\/>|, /).map((line) => (
            <Fragment key={line}>
              {line}
              <br />
            </Fragment>
          ))
        )}
      </div>
    </div>
  );
};

export default Summary;
